/**
 * @desc 登记事件
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.TheNewEventParameters,
): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/wap/event/add',
    data,
  });
}

export function mock(
  data: defs.TheNewEventParameters,
): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/mock/wap/event/add',
    data,
  });
}
